// src/components/modal/controleBar/ComandaItemModal.js
import React from "react";
import "./DeleteComandaItemModal.css";
import ModalPortal from '../../modalForm/ModalPortal';

export default function DeleteComandaItemModal({
  visible,
  motivo,
  setMotivo,
  onCancel,
  onConfirm
}) {
  if (!visible) return null;

  return (
    <ModalPortal show={visible}>
    <div className="del-overlay">
      <div className="del-container">

        <h2 className="del-title">Excluir Item</h2>
        <p className="del-subtitle">Informe o motivo da exclusão:</p>

        <textarea
          className="del-input"
          placeholder="Motivo..."
          value={motivo}
          onChange={(e) => setMotivo(e.target.value)}
        />

        <div className="del-btn-row">

          <button className="del-btn cancel" onClick={onCancel}>
            Cancelar
          </button>

          <button
            className="del-btn confirm"
            disabled={motivo.trim() === ""}
            style={{ opacity: motivo.trim() === "" ? 0.5 : 1 }}
            onClick={onConfirm}
          >
            Confirmar
          </button>

        </div>

      </div>
    </div>
    </ModalPortal>
  );
}
